export function capitalize( [ firstLetter, ...restOfWord ]: string ): string {
	return firstLetter.toUpperCase() + restOfWord.join( '' );
}
